import { adminWhatsappNumero } from '@/mocks/admin';

export default function FloatingWhatsApp() {
  const message = 'Olá, gostaria de falar com a equipe da Donnos.';

  return (
    <a
      href={`https://wa.me/${adminWhatsappNumero}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar com a Donnos pelo WhatsApp"
      className="fixed bottom-5 right-5 z-[60] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20 transition-all duration-300 hover:-translate-y-1 hover:bg-[#1ebe5d] focus:outline-none focus:ring-4 focus:ring-[#25D366]/30 sm:bottom-6 sm:right-6 sm:h-16 sm:w-16"
    >
      <i className="ri-whatsapp-line text-3xl sm:text-4xl"></i>
    </a>
  );
}
